import { RootActions, RootState } from "common/reducers";
import { List, Map, Record } from "immutable";
import { StatsRecord, statsFromJSON } from "common/records/Stats";
import { RECEIVE_STATS } from "common/reducers/stats.actions";

export const StatsStateRecord = Record({
  byOrgId: Map<number, List<StatsRecord>>(),
});

export const initialState = StatsStateRecord();
export type StatsState = typeof initialState;
export const model = "stats";

export const reducer = (state: RootState, action: RootActions): RootState => {
  if (state && !state.get(model)) {
    state = state.set(model, initialState);
  }

  switch (action.type) {
    case RECEIVE_STATS:
      return state.setIn([model, "byOrgId", action.payload.orgId], List(action.payload.stats.map(statsFromJSON)));

    default:
      return state;
  }
};
